import React from 'react';
import { Controller } from 'react-hook-form';
import { Checkbox } from 'primereact/checkbox';

function EventNotLinkedToCase({ control, setValue, isEditMode = false }) {
  return (
    <div className="d-flex align-items-center py-2 flex-wrap">
      <div className="col-md-4 col-12"></div>
      <div className="col-md-8 col-12">
        <Controller
          name="not_linked_to_case"
          control={control}
          defaultValue={true}
          render={({ field }) => (
            <div className="d-flex align-items-center">
              <Checkbox
                inputId={field.name}
                checked={field.value}
                disabled={isEditMode}
                onChange={(e) => {
                  field.onChange(e.checked);
                  if (e.checked) {
                    setValue('case', null);
                    setValue('case_name', '');
                  }
                }}
              />
              <label htmlFor={field.name} className={`ms-2 mb-0 disable-selection ${isEditMode ? 'text-muted' : 'pointer'}`}>
                Not linked to a case
              </label>
            </div>
          )}
        />
      </div>
    </div>
  );
}

export default EventNotLinkedToCase;
